<template>
  <a-form-model-item :label="field.label" :label-col="fieldLabelCol" :wrapper-col="fieldWrapperCol">
    <!-- 标题 -->
    <a-input v-if="field.key === 'title'" :value="form.title" allow-clear placeholder="问题标题" @change="handleInputChange('title', $event)" />
    <!-- 状态 -->
    <a-select v-else-if="field.key === 'status'" :value="form.status" mode="multiple" allow-clear placeholder="状态" @change="handleSelectChange('status', $event)">
      <a-select-option v-for="(item, index) in options.statusList" :key="index" :value="item.value">
        <a-tag :color="item.color">{{ item.label }}</a-tag>
      </a-select-option>
    </a-select>
    <!-- 处理人 -->
    <user-select v-else-if="field.key === 'handler'" :value="form.handler" mode="multiple" allow-clear show-search show-all placeholder="处理人" @change="handleSelectChange('handler', $event)" />
    <!-- 反馈人 -->
    <user-select v-else-if="field.key === 'reporter'" :value="form.reporter" mode="multiple" allow-clear show-search show-all placeholder="反馈人" @change="handleSelectChange('reporter', $event)" />
    <!-- 项目 -->
    <a-select v-else-if="field.key === 'projects'" :value="form.projects" mode="multiple" allow-clear placeholder="关联项目" @change="handleSelectChange('projects', $event)">
      <a-select-option v-for="(item, index) in options.projectOptions" :key="index" :value="item.id">{{ item.name }}</a-select-option>
    </a-select>
    <!-- 紧急程度 -->
    <a-select v-else-if="field.key === 'urgency'" :value="form.urgency" mode="multiple" allow-clear placeholder="紧急程度" @change="handleSelectChange('urgency', $event)">
      <a-select-option v-for="(item, index) in options.urgencys" :key="index" :value="item.value">
        <a-tag :color="item.color">{{ item.label }}</a-tag>
      </a-select-option>
    </a-select>
    <!-- 时间筛选 -->
    <a-input-group v-else-if="field.key === 'dateRange'" compact>
      <a-select :value="form.time_field" style="width: 30%" @change="handleSelectChange('time_field', $event)">
        <a-select-option value="created_time">创建时间</a-select-option>
        <a-select-option value="reported_time">上报时间</a-select-option>
        <a-select-option value="started_time">开始时间</a-select-option>
        <a-select-option value="resolved_time">解决时间</a-select-option>
        <a-select-option value="discovered_time">发现时间</a-select-option>
        <a-select-option value="located_time">定位时间</a-select-option>
        <a-select-option value="confirmed_time">业务确认时间</a-select-option>
      </a-select>
      <a-date-picker :value="form.start_time" style="width: 35%" placeholder="开始时间" value-format="YYYY-MM-DD" @change="handleDateChange('start_time', $event)" />
      <a-date-picker :value="form.end_time" style="width: 35%" placeholder="结束时间" value-format="YYYY-MM-DD" @change="handleDateChange('end_time', $event)" />
    </a-input-group>
    <!-- 反馈渠道 -->
    <a-select v-else-if="field.key === 'channel'" :value="form.channel" mode="multiple" allow-clear placeholder="反馈渠道" @change="handleSelectChange('channel', $event)">
      <a-select-option v-for="(item, index) in options.channels" :key="index" :value="item.value">
        {{ item.label }}
      </a-select-option>
    </a-select>
  </a-form-model-item>
</template>

<script>
import UserSelect from '@/components/User/UserSelect';

export default {
  name: 'ProblemFilterFormItem',
  components: { UserSelect },
  props: {
    field: {
      type: Object,
      required: true
    },
    form: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true,
      default: () => ({
        statusList: [],
        channels: [],
        urgencys: [],
        projectOptions: []
      })
    },
    searchData: {
      type: Object,
      required: true,
      default: () => ({
        story: {
          searching: false,
          data: []
        }
      })
    },
    reset: {
      type: Boolean,
      default: false
    },
    labelCol: {
      type: Object,
      default: null
    },
    wrapperCol: {
      type: Object,
      default: null
    }
  },
  computed: {
    fieldLabelCol() {
      return this.labelCol === null ? { span: this.field.labelSpan || 6 } : this.labelCol;
    },
    fieldWrapperCol() {
      return this.wrapperCol === null ? { span: this.field.wrapperSpan || 18 } : this.wrapperCol;
    }
  },
  methods: {
    handleInputChange(key, event) {
      this.$emit('change', { key, value: event.target.value });
    },

    handleSelectChange(key, value) {
      this.$emit('change', { key, value });
    },

    handleDateChange(key, value) {
      this.$emit('change', { key, value });
    },

    handleSearch(key, value) {
      this.$emit('search', { key, value });
    }
  }
};
</script>

<style lang="less" scoped>
:deep(.ant-form-item) {
  margin-bottom: 0px;

  .ant-form-item-label {
    text-align: right;
    color: #495057;
    padding-right: 8px;
  }
}

:deep(.ant-input),
:deep(.ant-select),
:deep(.ant-picker),
:deep(.ant-tree-select),
:deep(.ant-input-group),
:deep(.ant-calendar-picker) {
  width: 100%;
}
</style>
